import React from 'react';

import { Message } from 'semantic-ui-react';
import {colors} from 'style';

var style= {
    content: {
        position: 'relative'
    },
    time:{
        fontSize: '1.5em',
        position: 'absolute',
        left: '50%',
        top: '50%',
        width: '80px',
        height: '80px',
        marginLeft: '-40px',
        marginTop: '-40px',
        lineHeight: '80px',
        textAlign: 'center',
        color: colors.themeBlue,
    }
};

const Timer = ({formattedTimeLeft, path}) => (
        <div style={style.content}>
            <div style={style.time}>{formattedTimeLeft}</div>

            <svg id="theMap" width="150px" height="150px" viewBox="-100 -100 200 200">

              <circle cx="0" cy="0" r="100" fill={colors.themeBlue}></circle>
              <g id="arcs" transform=" translate(0 0) rotate(-90) scale(1 -1)">
                <path d={path} fill="#fff" opacity="1"></path>
              </g>
              <circle cx="0" cy="0" r="80" fill="#fff"></circle>

            </svg>
        </div>



);

export default Timer;



// WEBPACK FOOTER //
// ./src/modules/challenges/types/Timer.js